import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/steam-square': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M185.2 356.5c7.7-18.5-1-39.7-19.6-47.4l-29.5-12.2c11.4-4.3 24.3-4.5 36.4 0.5 12.2 5.1 21.6 14.6 26.7 26.7 5 12.2 5 25.6-0.1 37.7-10.5 25.1-39.4 37-64.6 26.5-11.6-4.8-20.4-13.6-25.4-24.2l28.5 11.8c18.6 7.8 39.9-0.9 47.6-19.4zM400 32c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48h-352c-26.5 0-48-21.5-48-48v-112.8l89.1 36.9c6 30 32.7 52.7 64.5 52.7 36.6 0 67.3-30.3 65.7-68.8l79-56.3c48.7 1.2 89.6-38.3 89.6-87.5 0-48.2-39.3-87.5-87.6-87.5s-87.6 39.3-87.6 87.5v1.1l-55.4 80.2c-14.5-0.8-28.7 3.1-40.7 11.3l-116.6-48.1v-160.7c0-26.5 21.5-48 48-48h352zM300.3 254.5c-32.2 0-58.4-26.1-58.4-58.3s26.2-58.3 58.4-58.3 58.4 26.2 58.4 58.3c0 32.1-26.2 58.3-58.4 58.3zM300.4 239.9c24.2 0 43.9-19.6 43.9-43.8 0-24.2-19.6-43.8-43.9-43.8-24.2 0-43.9 19.6-43.9 43.8 0 24.2 19.7 43.8 43.9 43.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/steam-square.js
// module id = 1032
// module chunks = 0